import { render, staticRenderFns } from "./OurServicesScreen.vue?vue&type=template&id=944ed54c&scoped=true"
import script from "./OurServicesScreen.vue?vue&type=script&lang=js"
export * from "./OurServicesScreen.vue?vue&type=script&lang=js"
import style0 from "./OurServicesScreen.vue?vue&type=style&index=0&id=944ed54c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944ed54c",
  null
  
)

export default component.exports